"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _formik = require("formik");
var _pickers = require("@material-ui/pickers");
var _moment = _interopRequireDefault(require("@date-io/moment"));
var _excluded = ["name", "picker", "field", "onChange"];
var DateTimePicker = function DateTimePicker(_ref) {
  var name = _ref.name,
    _ref$picker = _ref.picker,
    Picker = _ref$picker === void 0 ? _pickers.DateTimePicker : _ref$picker,
    _ref$field = _ref.field,
    field = _ref$field === void 0 ? true : _ref$field,
    _onChange = _ref.onChange,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (!field) {
    return /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(Picker, (0, _extends2["default"])({
      onChange: _onChange
    }, rest)));
  }
  return /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: name,
    render: function render(_ref2) {
      var fieldProps = _ref2.field,
        formProps = _ref2.form;
      return /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(Picker, (0, _extends2["default"])({
        value: fieldProps.value,
        onChange: function onChange(value) {
          if (!(0, _isNil["default"])(_onChange)) {
            _onChange(value);
          }
          formProps.setFieldValue(fieldProps.name, value);
        }
      }, rest)));
    }
  });
};
function Wrapper(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/_react["default"].createElement(_pickers.MuiPickersUtilsProvider, {
    utils: _moment["default"]
  }, children);
}
var _default = exports["default"] = DateTimePicker;
//# sourceMappingURL=index.js.map